import { DownloadForOffline, Visibility } from "@mui/icons-material";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import { useNavigate } from "react-router-dom";

const { Box, Typography } = require("@mui/material");

const filesDocuments = [
  { id: 1, name: "แบบคำขอโอนและรับโอน", file: "1.แบบคำขอโอน และรับโอน.pdf" },
  {
    id: 2,
    name: "หนังสือสัญญาซ์้อ - ขายรถ",
    file: "2.หนังสือสัญญาซื้อ-ขายรถยนต์ (ขาย).pdf",
  },
  { id: 3, name: "หนังสือมอบอำนาจ", file: "3.หนังสือมอบอำนาจ.pdf" },
  { id: 4, name: "สัญญารับฝาก", file: "4.หนังสือสัญญารับฝากขาย.pdf" },
  { id: 5, name: "สัญญาจำนำ", file: "5.หนังสือสัญญาจำนำ.pdf" },
];
const DocumentsList = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          ฟอร์มเอกสาร
        </Typography>
      </Box>

      <TableData
        data={filesDocuments}
        columns={[
          { key: "name", label: "ฟอร์มเอกสาร" },
          {
            key: "action",
            label: "Actions",
            render: (row) => (
              <Actions
                menuList={[
                  {
                    label: "ดูตัวอย่าง",
                    icon: <Visibility />,
                    onClick: () => {
                      //   handleRowClick(row, "detail");
                      navigate(`/car/documents/preview/${row.id}`);
                    },
                  },
                  {
                    label: "ดาวน์โหลดเอกสาร",
                    icon: <DownloadForOffline />,
                    onClick: () => {
                      const link = document.createElement("a");
                      link.href = `/assets/files/${row.file}`;
                      link.download = row.file;
                      link.click();
                      //   handleRowClick(row, "detail");
                    },
                  },
                ]}
              />
            ),
          },
        ]}
      />
    </Box>
  );
};
export default DocumentsList;
